import React, { useState } from "react";
import { Button, Icon, Segment, Grid } from "semantic-ui-react";
import clsx from "clsx";
import { EMOJI_CONSTATNT } from "../../../helpers/emojiConstant";
import pollsCss from "../../../assets/styles/polls/polls.module.scss";

export default function EmojiComponent({ draft, setDraft, handleDraftChange }) {
  const [emojiIndex, setEmojiIndex] = useState(0);

  const onEmojiSelect = (item) => {
    const updatedOptions = draft?.data?.poll_options?.map((option) => ({
      ...option,
      option_template_data: {
        ...option.option_template_data,
        emoji: `${item.char}`,
      },
    }));

    handleDraftChange("data.poll_options", updatedOptions);
  };

  const createSvgHeading = () => {
    return EMOJI_CONSTATNT.map((item, index) => (
      <Button
        icon
        key={index}
        title={item.name}
        className={clsx("emoji-panel-btn", {
          active: emojiIndex === index,
        })}
        onClick={() => setEmojiIndex(index)}
      >
        {item.char}
      </Button>
    ));
  };

  const createSvgBody = (index) => {
    return EMOJI_CONSTATNT[index].emojis.map((item, index) => (
      <Button
        key={index}
        title={item.name}
        className={pollsCss.emoji_panel_btn}
        onClick={() => onEmojiSelect(item)}
      >
        {item.char}
      </Button>
    ));
  };

  return (
    <Segment raised className={pollsCss.emoji_panel}>
      <Grid>
        <Grid.Row className={pollsCss.emoji_panel_heading}>
          <Grid.Column>
            <div className={pollsCss.emoji_panel_buttons}>
              {createSvgHeading()}
            </div>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column className={pollsCss.emoji_panel_body}>
            {createSvgBody(emojiIndex)}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Segment>
  );
}
